import { Map } from 'immutable';

import {
    SET_EVENTS,
    RESET_EVENTS,
    SET_BOUNDS_EVENTS,
} from './actions';

const events = (state = Map({ loreEvents: [], leeEvents: [], loading: false, bounds: null }), action) => {
    switch (action.type) {
      case SET_EVENTS:
        return state.set('loreEvents', action.payload.lore)
                    .set('leeEvents', action.payload.lee)
                    .set('loading', false);
      case RESET_EVENTS:
        return state.set('loreEvents', [])
                    .set('leeEvents', [])
                    .set('loading', true);
      case SET_BOUNDS_EVENTS:
        return state.set('bounds', action.payload.bounds);
      default:
        return state;
    }
};

export default events;


// WEBPACK FOOTER //
// ./src/Events/reducers.js